<template>
  <a-card class="cardMain"
          :tab-list="tabList"
          :active-tab-key="activeKey"
          @tabChange="(key: any) => onTabChange(key, 'key')">
    <template #customTab="item">
      <span v-if="item.key === 'role'">
        {{ item.tab }}
      </span>
    </template>
    <keep-alive>
      <Role v-if="activeKey == 'role'"></Role>
      <User v-else-if="activeKey == 'user'"></User>
    </keep-alive>
  </a-card>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from 'vue'
import Role from './PositionsViewRightMenuRole.vue'
import User from './PositionsViewRightMenuUser.vue'
const activeKey = ref('role')
const tabList = reactive([{
  key: 'role',
  tab: '角色',
}, {
  key: 'user',
  tab: '用户',
}])

onMounted(() => {
  return
})

const onTabChange = (value: string, type: string) => {
  if (type === 'key') {
    activeKey.value = value
  }
}
</script>

<style lang="less" scoped>
</style>
